define('viewmodels/modals/dialogs/ChangeRealityCheckIntervalDialog',['knockout', 'underscore'], function (ko, _) {

    var ChangeRealityCheckEmailDialog = function(
        dialog,
        formFields,
        changeRealityCheckIntervalModel,
        realityCheckContent,
        currentIntervalInMinutes
    ) {
        var self = this;

        self.currentIntervalInMinutes = currentIntervalInMinutes;

        changeRealityCheckIntervalModel.realityCheckIntervalMinutes(currentIntervalInMinutes || 60);

        self.dialog = dialog;

        self.isManualMode = ko.observable(false);

        self.suggestedIntervals = ko.pureComputedArray(function() {
            return [60, 90, 120];
        }).map(function(value) {
            return {
                value: realityCheckContent.findFieldByName('reality_check_interval_minutes')
                    .replacements( { intervalMinutes : value }),
                select: function() {
                    changeRealityCheckIntervalModel.realityCheckIntervalMinutes(value);
                },
                isSelected: ko.pureComputed(function() {
                    return changeRealityCheckIntervalModel.realityCheckIntervalMinutes() == value;
                })
            };
        });

        self.intervalMinutesField = formFields.numberField(changeRealityCheckIntervalModel.realityCheckIntervalMinutes);
        self.intervalMinutesFieldDisplayValue = realityCheckContent.findFieldByName('reality_check_interval_minutes')
            .replacements(
                { intervalMinutes : changeRealityCheckIntervalModel.realityCheckIntervalMinutes}
            );

        self.command = changeRealityCheckIntervalModel.createCommand(function() {
            self.close();
        });

        self.useManualMode = function() {
            self.isManualMode(true);
            changeRealityCheckIntervalModel.realityCheckIntervalMinutes(null);
        };

        // CMS content
        self.title = realityCheckContent.findFieldByName('reality_check_feature_title');
        self.confirmChangeInterval = realityCheckContent.findFieldByName('reality_check_confirm_change_interval');
        self.intervalQuestion = realityCheckContent.findFieldByName('reality_check_interval_question');
        self.currentIntervalLabel = realityCheckContent.findFieldByName('reality_check_current_interval_label')
            .replacements(
                { intervalMinutes: currentIntervalInMinutes }
            );

    };

    ChangeRealityCheckEmailDialog.prototype.close = function() {

        this.dialog.close(this);
    };

    return ChangeRealityCheckEmailDialog;
});

